module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Emergency Services-23f323537399c7f7049007e42dbc5bf4.png";